<template>
    <div>
        <List>
            <router-link :to="{ name: 'lsvaOverview' }">
                <ListItem>
                    <div class="l-inline l-gap-3 l-center-v">
                        <div>
                            <DashboardIcon width="24" height="24" />
                        </div>

                        <div>{{ $t('overview') }}</div>
                    </div>
                </ListItem>
            </router-link>

            <router-link :to="{ name: 'lsvaTrucks' }">
                <ListItem>
                    <div class="l-inline l-gap-3 l-center-v">
                        <div>
                            <TruckIcon width="24" height="24" />
                        </div>

                        <div>{{ $t('trucks') }}</div>
                    </div>
                </ListItem>
            </router-link>

            <router-link :to="{ name: 'lsvaTrailers' }">
                <ListItem>
                    <div class="l-inline l-gap-3 l-center-v">
                        <div>
                            <TrailerIcon width="24" height="24" />
                        </div>

                        <div>{{ $t('trailers') }}</div>
                    </div>
                </ListItem>
            </router-link>
        </List>
    </div>
</template>

<script>
import DashboardIcon from '@/components/icons/DashboardIcon'
import List from '@/components/List'
import ListItem from '@/components/ListItem'
import TrailerIcon from '@/components/icons/TrailerIcon'
import TruckIcon from '@/components/icons/TruckIcon'

export default {
    name: 'LsvaMenu',
    components: {
        DashboardIcon,
        List,
        ListItem,
        TrailerIcon,
        TruckIcon,
    },
}
</script>

<i18n>
{
    "en": {
        "overview": "Overview",
        "trailers": "Trailers",
        "trucks": "Trucks"
    },
    "de": {
        "overview": "Übersicht",
        "trailers": "Anhänger",
        "trucks": "Lastwagen"
    },
    "fr": {
        "overview": "Aperçu",
        "trailers": "Remorques",
        "truck": "Camions"
    },
    "it": {
        "overview": "Sommario",
        "trailers": "Rimorchi",
        "truck": "Camion"
    }
}
</i18n>

<style lang="scss" scoped>
a {
    &:first-child {
        &.router-link-exact-active {
            .list-item {
                background-color: $color-gray-light;
            }
        }
    }

    &:not(:first-child) {
        &.router-link-active {
            .list-item {
                background-color: $color-gray-light;
            }
        }
    }

    svg {
        display: block;
    }
}
</style>
